import Repository from '../Repository';

export default {

	getComments() {
		var response = Repository.get('Comment/GetComments', {
			params: {
				languageId: 1,
				commentTypeId: 1
			}
		});

		/*let response = {
			data :{
				success: true,
				data:[
					{id: 1, value:'Marker - marking error - adjust mark without uploading a new component'},
					{id: 2, value:'Moderation - Adjust mark without upload of a new components'},
					{id: 3, value:'Irregularity reported - mark adjust to zero'},
				]
			}
		};*/
		return response;
	}

}
